import React from 'react'
import PropTypes from 'prop-types'
import Chip from '@material-ui/core/Chip'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'

import './styles.scss'

const getChipClass = (balance) => {
  if (balance > 0) return 'copay-balance-chip--positive'
  if (balance < 0) return 'copay-balance-chip--negative'
  return 'copay-balance-chip--zero'
}

const CopaidSessionsBalanceChip = ({ balance, onClick }) => {
  const handleClick = (event) => {
    if (!onClick) return
    event.stopPropagation()
    onClick(event)
  }

  return (
    <Chip
      size='small'
      icon={<AttachMoneyIcon />}
      label={`Balance Copago: ${balance > 0 ? `+${balance}` : balance}`}
      className={`copay-balance-chip ${getChipClass(balance)} ${onClick ? 'copay-balance-chip--clickable' : ''}`}
      onClick={onClick ? handleClick : undefined}
    />
  )
}

CopaidSessionsBalanceChip.propTypes = {
  balance: PropTypes.number.isRequired,
  onClick: PropTypes.func,
}

export default CopaidSessionsBalanceChip
